import { render, staticRenderFns } from "./Placa.vue?vue&type=template&id=3e98a4a3"
import script from "./Placa.vue?vue&type=script&lang=js"
export * from "./Placa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports